export default __webpack_public_path__ + "static/media/landing_section_img.e0356e6a.png";